// src/pages/HomePage/HomePage.js
import React from 'react';
import Navbar from '../../components/common/Navbar/Navbar';
import Footer from '../../components/common/Footer/Footer';
import Hero from '../../components/home/Hero/Hero';
import ScrollToTop from '../../components/common/ScrollToTop/ScrollToTop';
import SchoolsSection from '../../components/home/SchoolsSection/SchoolsSection';
import AdmissionsSection from '../../components/home/AdmissionsSection/AdmissionsSection';
import EventsSection from '../../components/home/EventsSection/EventsSection';
import ContactSection from '../../components/home/ContactSection/ContactSection';
import useScrollReveal from '../../hooks/useScrollReveal';
import './HomePage.css';

const HomePage = () => {
    useScrollReveal();

    return (
        <div className="homepage">
            <Navbar />
            <main>
                <Hero />
                <AdmissionsSection />
                <SchoolsSection />
                <EventsSection />
                <ContactSection />
            </main>
            <Footer />
            <ScrollToTop />
        </div>
    );
};

export default HomePage;